<template>
	<div>
	<div v-if="whatsappStyle" class="wa-sidebar-header">
	  <div class="d-flex align-center wa-header-actions">
	    <v-avatar color="#00a884" size="42">
	      <v-icon color="white">mdi-whatsapp</v-icon>
	    </v-avatar>
	    <div class="ml-3">
	      <div class="wa-title">{{ nameTwilio }}</div>
	      <div class="wa-subtitle">
	        {{ cantidadChats != null ? cantidadChats : 0 }} conversaciones
	        <span v-if="tiempoCargaMs != null"> · {{ tiempoCargaMs }} ms</span>
	      </div>
	    </div>
	  </div>

	  <div class="d-flex align-center">
	    <template v-if="['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
	      <v-tooltip bottom>
	        <template v-slot:activator="{ on, attrs }">
	          <v-btn icon small v-bind="attrs" v-on="on" @click="abrirModalAsignadosPorPlantel()">
	            <v-icon color="#54656f">mdi-office-building</v-icon>
	          </v-btn>
	        </template>
	        <span>Mostrar alumnos asignados y no asignados por plantel</span>
	      </v-tooltip>

	      <v-tooltip bottom>
	        <template v-slot:activator="{ on, attrs }">
	          <v-btn icon small v-bind="attrs" v-on="on" @click="abrirModalMensajesSinResponder()">
	            <v-icon color="#54656f">mdi-message-bulleted-off</v-icon>
	          </v-btn>
	        </template>
	        <span>Reporte de mensajes sin responder</span>
	      </v-tooltip>

	      <v-tooltip bottom v-if="[1,334,3015,568,'1','334','3015','568',32,'32'].includes( getdatosUsuarioERPERP.iderp )">
	        <template v-slot:activator="{ on, attrs }">
	          <v-btn icon small v-bind="attrs" v-on="on" @click="exportarExcelDirecto( filterChats, 'Alumnos_Sin_Responder' )">
	            <v-icon color="#54656f">mdi-microsoft-excel</v-icon>
	          </v-btn>
	        </template>
	        <span>Exportar reporte de mensajes sin responder</span>
	      </v-tooltip>
	    </template>

	    <v-tooltip bottom v-if="!['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn icon small v-bind="attrs" v-on="on" @click="dialogSeguimiento = true">
	          <v-icon color="#54656f">mdi-information-outline</v-icon>
	        </v-btn>
	      </template>
	      <span>Guía para realizar seguimiento efectivo de prospectos</span>
	    </v-tooltip>

	    <v-tooltip bottom v-if="puedeReasignarMasivo">
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn
	          icon
	          small
	          v-bind="attrs"
	          v-on="on"
	          :disabled="!(cantidadSeleccionados > 0)"
	          @click="$emit('reasignar-masivo')"
	        >
	          <v-badge
	            :value="cantidadSeleccionados > 0"
	            :content="cantidadSeleccionados"
	            color="#00a884"
	            overlap
	          >
	            <v-icon :color="cantidadSeleccionados > 0 ? '#00a884' : '#adb5bd'">mdi-account-switch</v-icon>
	          </v-badge>
	        </v-btn>
	      </template>
	      <span>
	        {{ cantidadSeleccionados > 0
	          ? `Reasignar ${cantidadSeleccionados} seleccionado${cantidadSeleccionados === 1 ? '' : 's'}`
	          : 'Selecciona chats en la lista para reasignar' }}
	      </span>
	    </v-tooltip>

	    <v-tooltip bottom v-if="showButtons() && !['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
	      <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
	        <v-menu bottom offset-y>
	          <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
	            <v-btn icon small v-bind="{...attrsMenu, ...attrsTooltip}" v-on="{...onMenu, ...onTooltip}">
	              <v-icon color="#54656f">mdi-account-switch-outline</v-icon>
	            </v-btn>
	          </template>
	          <v-list dense class="wa-vendedoras-menu" style="min-width: 440px; max-width: 560px;">
	            <v-list-item
	              v-for="(item, index) in vendedorasConUsuario"
	              :key="index"
	              @click="handleSeleccionVendedora(item)"
	            >
	              <v-list-item-icon class="mr-2">
	                <v-icon color="#00a884">mdi-account</v-icon>
	              </v-list-item-icon>
	              <v-list-item-content class="py-1">
	                <v-list-item-title class="text-caption text-truncate">{{ item.nombre }}</v-list-item-title>
	              </v-list-item-content>
	              <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
	                <v-avatar size="16" color="green" class="mr-1">
	                  <v-icon x-small dark>mdi-clock</v-icon>
	                </v-avatar>
	                <span class="text-caption mr-2">{{ item.verdes || 0 }}</span>
	                <v-avatar size="16" color="yellow darken-1" class="mr-1">
	                  <v-icon x-small>mdi-clock</v-icon>
	                </v-avatar>
	                <span class="text-caption mr-2">{{ item.amarillos || 0 }}</span>
	                <v-avatar size="16" color="blue" class="mr-1">
	                  <v-icon x-small dark>mdi-message</v-icon>
	                </v-avatar>
	                <span class="text-caption mr-2">{{ item.sinResponder || 0 }}</span>
	                <v-tooltip bottom>
	                  <template v-slot:activator="{ on, attrs }">
	                    <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
	                      <v-avatar size="16" :color="item.horaSinContestarColor || 'grey'" class="mr-1">
	                        <v-icon x-small dark>mdi-message-clock</v-icon>
	                      </v-avatar>
	                      <span class="text-caption text-no-wrap" :class="item.horaSinContestarClase">{{ item.horaSinContestar || '—' }}</span>
	                    </span>
	                  </template>
	                  <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
	                </v-tooltip>
	              </v-list-item-action>
	            </v-list-item>
	          </v-list>
	        </v-menu>
	      </template>
	      <span>Filtra chats por vendedora o asesor</span>
	    </v-tooltip>

	    <v-tooltip
	      v-if="mostrarDescargarConversaciones"
	      bottom
	    >
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn
	          icon
	          small
	          v-bind="attrs"
	          v-on="on"
	          class="mr-1"
	          :loading="exportandoUltimasConversaciones"
	          :disabled="exportandoUltimasConversaciones || !(cantidadChats > 0)"
	          @click="$emit('descargar-ultimas-conversaciones')"
	        >
	          <v-icon color="#54656f">mdi-download-multiple</v-icon>
	        </v-btn>
	      </template>
	      <span>Descargar todas las conversaciones (JSON)</span>
	    </v-tooltip>

	    <v-tooltip bottom v-if="nameTwilio === 'TWILIO RH'">
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('abrir-reporte')">
	          <v-icon color="#54656f">mdi-chart-box-outline</v-icon>
	        </v-btn>
	      </template>
	      <span>Reporte por vacante</span>
	    </v-tooltip>

	    <v-tooltip bottom v-if="nameTwilio === 'TWILIO RH'">
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('abrir-horarios')">
	          <v-icon color="#54656f">mdi-calendar-clock</v-icon>
	        </v-btn>
	      </template>
	      <span>Horarios de entrevista</span>
	    </v-tooltip>

	    <v-tooltip bottom>
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('initialize')">
	          <v-icon color="#54656f">mdi-refresh</v-icon>
	        </v-btn>
	      </template>
	      <span>Actualiza la lista de conversaciones</span>
	    </v-tooltip>
	  </div>
	</div>

	<!-- TITULO DEL TOOLBAR -->
	<v-toolbar
	  v-else
	  class="elevation-0"
	  color="#00A548"
	  dark
	  tile
	>
	  {{ nameTwilio }}

    <!-- Mostrar la cantidad de chats -->
    | {{ cantidadChats }} |

    <v-tooltip bottom color="blue" max-width="300" v-if="!['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class="ml-2" 
          @click="dialogSeguimiento = true" 
          v-bind="attrs" 
          v-on="on"
        >mdi-information</v-icon>
      </template>
      <span>Guía para realizar seguimiento efectivo de prospectos</span>
    </v-tooltip>

    <!-- <v-tooltip bottom color="blue" max-width="300" v-if="getdatosUsuarioERPERP.idpuesto != 19 && ['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class="ml-3" 
          @click="abrirModalAsignados( ) " 
          v-bind="attrs" 
          v-on="on"
        >mdi-account-group</v-icon>
      </template>
      <span>Mostrar alumnos asignados y no asignados</span>
    </v-tooltip> -->

    <!-- Modal para ver por plantel los alumnos asignados y no asignados -->
    <v-tooltip bottom color="blue" max-width="300" v-if="['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class="ml-3" 
          @click="abrirModalAsignadosPorPlantel( ) " 
          v-bind="attrs" 
          v-on="on"
        >
          <!-- Icono de una sucursal -->
          mdi-office-building
        </v-icon> 
      </template>
      <span>Mostrar alumnos asignados y no asignados por plantel</span>
    </v-tooltip>

    <!-- Modal para ver por plantel los alumnos asignados y no asignados -->
    <v-tooltip bottom color="blue" max-width="300" v-if="['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class="ml-3" 
          @click="abrirModalMensajesSinResponder( ) " 
          v-bind="attrs" 
          v-on="on"
        >
          <!-- Icono de una sucursal -->
          mdi-message-bulleted-off
        </v-icon> 
      </template>
      <span>Reporte de mensajes sin responder</span>
    </v-tooltip>

    <!-- Modal para ver por plantel los alumnos asignados y no asignados -->
    <v-tooltip bottom color="blue" max-width="300" v-if="['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio ) && [1,334,3015,568,'1','334','3015','568',32,'32'].includes( getdatosUsuarioERPERP.iderp )">
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          class="ml-3" 
          @click="exportarExcelDirecto( filterChats, 'Alumnos_Sin_Responder' )" 
          v-bind="attrs" 
          v-on="on"
        >
          <!-- Icono para descargar excel -->
          mdi-microsoft-excel
        </v-icon> 
      </template>
      <!--  -->
      <span>Reporte de mensajes sin responder</span>
    </v-tooltip>

	  <v-spacer></v-spacer>
	  
    <v-tooltip bottom color="blue" max-width="300" v-if="showButtons() && !['CRM ALUMNOS','CRM ALUMNOS FAST'].includes( nameTwilio )">
      <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
        <v-menu
          top
          offset-y
        >
          <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
            <v-btn
              color="white"
              v-bind="{...attrsMenu, ...attrsTooltip}"
              v-on="{...onMenu, ...onTooltip}"
              class="mr-3 ml-4"
              x-small
              fab
            >
              <v-icon color="green">mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list dense class="wa-vendedoras-menu" style="min-width: 440px; max-width: 560px;">
            <v-list-item
              v-for="(item, index) in vendedorasConUsuario"
              :key="index"
              @click="handleSeleccionVendedora(item)"
            >
              <v-list-item-icon class="mr-2">
                <v-icon color="grey">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="py-1">
                <v-list-item-title class="text-caption text-truncate">{{ item.nombre }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                <v-avatar size="16" color="green" class="mr-1">
                  <v-icon x-small dark>mdi-clock</v-icon>
                </v-avatar>
                <span class="text-caption mr-2">{{ item.verdes || 0 }}</span>
                <v-avatar size="16" color="yellow darken-1" class="mr-1">
                  <v-icon x-small>mdi-clock</v-icon>
                </v-avatar>
                <span class="text-caption mr-2">{{ item.amarillos || 0 }}</span>
                <v-avatar size="16" color="blue" class="mr-1">
                  <v-icon x-small dark>mdi-message</v-icon>
                </v-avatar>
                <span class="text-caption mr-2">{{ item.sinResponder || 0 }}</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                      <v-avatar size="16" :color="item.horaSinContestarColor || 'grey'" class="mr-1">
                        <v-icon x-small dark>mdi-message-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption text-no-wrap" :class="item.horaSinContestarClase">{{ item.horaSinContestar || '—' }}</span>
                    </span>
                  </template>
                  <span>Hora del último sin responder (sin SPAM / no interesado). Verde: ≤10 min. Rojo: más de 10 min.</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <span>Filtra chats por vendedora o asesor</span>
    </v-tooltip>

    <v-tooltip bottom color="blue" max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          @click="$emit('initialize')"
          class="mr-2"
          fab
          color="white"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="green">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>Actualiza la lista de conversaciones</span>
    </v-tooltip>

	</v-toolbar>

	  <v-dialog
      v-model="dialogSeguimiento"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card outlined class="pa-4">
	      <v-card-title class="text-h6 font-weight-bold">
	        Pasos para realizar un buen seguimiento
	      </v-card-title>

	      <v-divider class="my-3" />

	      <!-- Filtro inicial en Twilio -->
	      <section>
	        <h3 class="text-subtitle-1 font-weight-bold mb-2">Filtro inicial en Twilio</h3>

	        <p class="mb-3">
	          Al ingresar a Twilio, siempre debemos colocar el primer filtro:
	          <strong>INTERACCIÓN</strong>
	        </p>

	        <!-- Imagen opcional -->
	        <v-img
	          class="rounded-lg mb-2"
	          max-width="520"
	          src="@/assets/filtro_seguimiento.png"
	          alt="Filtro Interacción en Twilio"
	          contain
	        />

	        <p class="text-caption grey--text">
	          (Opcional) Inserta aquí la captura del filtro de Twilio.
	        </p>
	      </section>

	      <v-divider class="my-4" />

	      <!-- Orden de prioridad -->
	      <section>
	        <h3 class="text-subtitle-1 font-weight-bold mb-2">
	          Orden de prioridad para seguimiento de prospectos
	        </h3>

	        <p class="mb-4">
	          El seguimiento <b>debe realizarse estrictamente en el siguiente orden</b>, de mayor a menor prioridad:
	        </p>

	        <v-list dense>
	          <v-list-item v-for="(item, idx) in prioridades" :key="idx" class="align-start">
	            <v-list-item-content>
	              <div class="d-flex align-start">
	                <div class="mr-3 font-weight-bold">
	                  {{ idx + 1 }}.
	                </div>

	                <div>
	                  <div class="font-weight-bold">
	                    {{ item.titulo }}
	                  </div>

	                  <div class="mt-1">
	                    <span class="font-weight-bold">Por qué:</span>
	                    <span> {{ item.porque }}</span>
	                  </div>
	                </div>
	              </div>
	            </v-list-item-content>
	          </v-list-item>
	        </v-list>
	      </section>

	      <v-divider class="my-4" />

	      <!-- Fuera de seguimiento activo -->
	      <section>
	        <h3 class="text-subtitle-1 font-weight-bold mb-2">
	          Fuera de seguimiento activo
	        </h3>

	        <p class="mb-2">
	          Estos estatus no requieren seguimiento:
	        </p>

	        <v-chip-group column>
	          <v-chip
	            v-for="(s, i) in noRequieren"
	            :key="i"
	            color="grey lighten-3"
	            class="ma-1"
	          >
	            {{ s }}
	          </v-chip>
	        </v-chip-group>
	      </section>
	    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosAsignados"
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card outlined class="pa-4">
	      <v-card-title class="text-h6 font-weight-bold">
	        Alumnos asignados y no asignados
	      </v-card-title>

        <v-card-text>
          <v-radio-group v-model="opAsignado" row>
            <v-radio value="1" :label="'Asignados (' + alumnos.filter( el => el.twilio_asignado ).length + ')'"></v-radio>
            <v-radio value="2" :label="'No asignados (' + (alumnos.length - alumnos.filter( el => el.twilio_asignado ).length) + ')'"></v-radio>
            <v-radio value="3" :label="'Todos (' + alumnos.length + ')'"></v-radio>
          </v-radio-group>

          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="filterAlumnosAsignados"
                class="elevation-0"
                :search="search"
                :mobile-breakpoint="100"
                dense

              >

                <template v-slot:item.twilio_asignado="{ item }">
                  <span>
                    <v-icon v-if="item.twilio_asignado" color="green" small left>mdi-checkbox-blank-circle</v-icon>
                  </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
	    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosAsignadosPorPlantel"
      max-width="1200px"
      transition="dialog-transition"
    >
      <v-card outlined class="pa-4">
	      <v-card-title class="text-h6 font-weight-bold">
	        Alumnos asignados y no asignados
	      </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersAlumnosAsignadosPorPlantel"
                :items="filterAlumnosAsignadosPorPlantel"
                class="elevation-0"
                :search="search"
                :mobile-breakpoint="100"
                dense
                :loading="alumnosCalificaciones.length == 0"
                :loading-text="alumnosCalificaciones.length == 0 ? 'Cargando calificaciones...' : ''"
              >

                <template v-slot:item.sin_conversacion="{ item }">
                  <v-chip color="primary" dark small @click="verAlumnosSinConversacion( item.sin_conversacion_alumnos )" v-if="alumnosCalificaciones.length > 0">
                    {{  item.sin_conversacion }}
                  </v-chip>
                  <span v-else>{{  item.sin_conversacion }}</span>
                </template>

                
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
	    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosSinResponder"
      max-width="1200px"
      transition="dialog-transition"
    >
      <v-card outlined class="pa-4">
	      <v-card-title class="text-h6 font-weight-bold">
	        Reporte de mensajes sin responder
	      </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersAlumnosSinResponder"
                :items="filterAlumnosSinResponder"
                class="elevation-0"
                :search="search"
                :mobile-breakpoint="100"
                dense
              >

                <template v-slot:item.sin_conversacion="{ item }">
                  <v-chip color="primary" dark small @click="verAlumnosSinConversacion( item.sin_conversacion_alumnos )">
                    {{  item.sin_conversacion }}
                  </v-chip>
                </template>

                
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
	    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosSinConversacion"
      max-width="1800px"
      transition="dialog-transition"
    >
      <v-card outlined class="pa-4">
        <v-card-title class="text-h6 font-weight-bold">
          Alumnos sin conversación
          <v-spacer></v-spacer>
          <v-switch v-model="nivel1" label="Nivel 1" color="primary" hide-details dense class="mr-2"></v-switch>
          <!-- bOTON PARA DESCARGAR POR EXCEL -->
          <v-btn color="primary" dark small @click="exportarExcelDirecto( filterAlumnosSinConversacion, 'Alumnos_Sin_Conversacion' )">
            <v-icon color="white">mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pt-0">
          <v-chip small class="mr-2" color="grey lighten-2">
            Total: {{ totalAlumnosSinConversacion }}
          </v-chip>
          <v-chip small class="mr-2" color="green lighten-4">
            Activos: {{ activosSinConversacion }}
          </v-chip>
          <v-chip small class="mr-2" color="red lighten-4">
            Bajas: {{ bajasSinConversacion }}
          </v-chip>
          <v-chip small color="blue lighten-4">
            Por ligar: {{ porLigarSinConversacion }}
          </v-chip>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersAlumnosSinConversacion"
                :items="filterAlumnosSinConversacion"
              >
                <!-- Agragar botón para subir imagen a cada alumnos -->
                <template v-slot:item.imagen_twilio="{ item }">
                  <v-btn
                    v-if="!item.imagen_twilio"
                    color="primary"
                    x-small
                    @click="subirImagen(item)"
                  >
                    <v-icon small>mdi-image</v-icon>
                  </v-btn>
                </template>

                <template v-slot:item.baja_sn="{ item }">
                  <v-checkbox
                    v-model="item.baja_sn"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    dense
                    @change="actualizarBaja(item)"
                  ></v-checkbox>
                </template>
                
                <template v-slot:item.comentarios="props">
                  <v-edit-dialog
                    large
                    :return-value.sync="props.item.comentarios"
                    @save="saveComentarios(props.item)"
                  >
                    {{ props.item.comentarios }}
                    <span class="text-caption grey--text">Click para editar</span>
                    <template v-slot:input>
                      <v-textarea
                        v-model="props.item.comentarios"
                        label="Comentarios"
                      ></v-textarea>
                    </template>
                  </v-edit-dialog>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSubirImagen" max-width="400px" @keydown.ctrl="pegar">
      <v-card 
        v-if="alumnoSeleccionado"
        max-width="600px" 
      >
        <v-card-title class="text-subtitle-1">
          Subir imagen
        </v-card-title>
        <v-card-text>
          <v-tooltip bottom color="blue" max-width="300" v-if="!file">
            <template v-slot:activator="{ on, attrs }">
              <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false" v-bind="attrs" v-on="on">
                <div class="dropZone-info" @drag="onChange">
                  <span class="fa fa-cloud-upload dropZone-title"></span>
                  <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                  <div class="dropZone-upload-limit-info">
                    <div>Extensión: png, jpg, jpeg, svg</div>
                    <div>Tamaño máximo: 10 MB</div>
                  </div>
                </div>
                <input type="file" @change="onChange">
              </div>
            </template>
            <span>Sube el comprobante de pago (captura de transferencia)</span>
          </v-tooltip>

          <div v-else>
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="red" class="mb-2" dense @click="removeFile" fab small dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar el comprobante cargado</span>
            </v-tooltip>
            <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="dialogSubirImagen = false"
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	</div>
</template>
<script>
  import axios          from 'axios';
  import { mapGetters, mapActions } from 'vuex'
  import funcionesExcel      from '@/mixins/funcionesExcel'
  import { Clipboard } from "@capacitor/clipboard";
  import { esUsuarioTwilioAdmin } from '@/config/twilioUsuariosAdmin'
  import {
    aplicarHoraSinContestar,
    maxHoraSinContestarDeMap,
    colorHoraSinContestar,
    colorHoraSinContestarGrupo,
    claseTextoHoraSinContestar,
  } from '@/utils/twilioFechaMexico'


  export default {

    mixins: [  funcionesExcel ],


  	props:[
  		'nameTwilio',
  		'vendedorasTwilio',
  		'filtroVendedora',
  		'vendedoras_plantel',
      'cantidadChats',
      'tiempoCargaMs',
      'alumnos',
      'planteles',
      'filterChats',
      'whatsappStyle',
      'mostrarDescargarConversaciones',
      'exportandoUltimasConversaciones',
      'conteoTiempoVendedores',
      'puedeReasignarMasivo',
      'cantidadSeleccionados',
  	],

    async created(){
    },

    data: () => ({

      alumnosCalificaciones:[],

    	dialogSeguimiento: false,

      dialogAlumnosAsignados: false,
      dialogAlumnosAsignadosPorPlantel: false,
      dialogAlumnosSinResponder:false,
      opAsignado: 3, 
      search:'',
      headers: [
        { text: 'ID'          , value: 'id_alumno'       },
        { text: 'Matricula'   , value: 'matricula'       },
        { text: 'Alumno'      , value: 'alumno'          },
        { text: 'Grupo'       , value: 'grupo'           },
        { text: 'Asignado'    , value: 'twilio_asignado' },
      ],
      
      headersAlumnosAsignadosPorPlantel: [
        { text: 'Plantel'                    , value: 'plantel'           },
        { text: 'Cant. Alumnos'              , value: 'cant_alumnos'      },
        { text: 'Sin conversación'           , value: 'sin_conversacion'  },
        { text: 'Con conversación No Asig.'  , value: 'con_conversacion'  },
        { text: 'Asignados'                  , value: 'asignados'         },
        { text: 'Sin asignar'                , value: 'sin_asignar'       },
      ],

      headersAlumnosSinConversacion: [
        { text: 'ID'                , value: 'id_alumno'       },
        { text: 'Matricula'         , value: 'matricula'       },
        { text: 'Alumno'            , value: 'alumno'          },
        { text: 'Baja'              , value: 'baja_sn'         },
        { text: 'Grupo'             , value: 'grupo'           },
        { text: 'Vendedora'         , value: 'nombre_vendedora'},
        { text: 'Imagen'            , value: 'imagen_twilio'   },
        { text: 'Texto'             , value: 'twilio_texto'    },
        { text: 'Comentarios'       , value: 'comentarios'     },
        { text: 'Calificación'      , value: 'calificacion'     },
        { text: 'Calificación Ant.' , value: 'calificacion_anterior'     },
        { text: 'Ultimo Movimiento' , value: 'ultimo_movimiento'     },
        { text: 'Pagado'            , value: 'pagado'     },
        { text: 'Adeudo'            , value: 'adeudo'     },
      ],

      headersAlumnosSinResponder: [
        { text: 'ID'            , value: 'id_plantel'        },
        { text: 'Plantel'       , value: 'plantel'           },
        { text: 'Sin responder' , value: 'sin_responder'     },
        { text: 'SR Cerrados'   , value: 'cerrados'          },
        { text: 'SR Abiertos'   , value: 'abiertos'          },
        { text: 'SR Por cerrar' , value: 'porcerrar'         },
        { text: 'Ultimo MSN'    , value: 'ultimoMensaje'     },
        // { text: 'Grupo'       , value: 'grupo'           },
        // { text: 'Vendedora'   , value: 'nombre_vendedora'},
        // { text: 'Imagen'      , value: 'imagen_twilio'   },
        // { text: 'Texto'       , value: 'twilio_texto'    },
      ],
    	// Cambia esta ruta por tu imagen real
      imgTwilio: "/img/twilio-filtro-interaccion.png",

      prioridades: [
        {
          titulo: "NUEVO",
          porque:
            "El prospecto escribe a varias escuelas. La primera que responde toma el control y gana la venta."
        },
        {
          titulo: "PENDIENTE DE PAGO",
          porque:
            "El cliente ya decidió. Si no cobramos rápido, otra opción puede robarnos el cierre."
        },
        {
          titulo: "EXAMEN REALIZADO",
          porque:
            "Ya invirtió tiempo y se visualiza dentro. Es uno de los momentos más fáciles para cerrar."
        },
        {
          titulo: "CON CITA AGENDADA",
          porque:
            "Quien agenda tiene intención. Confirmar asegura que avancemos al cierre."
        },
        {
          titulo: "LLAMADA AGENDADA",
          porque:
            "Cada llamada es una oportunidad real de venta. Perderla es perder dinero."
        },
        {
          titulo: "CLIENTE POTENCIAL",
          porque:
            "El interés sigue vivo. Si tardamos, el prospecto se enfría o se va con otra escuela."
        },
        {
          titulo: "EXAMEN ENVIADO",
          porque:
            "Si no lo empujamos, no lo hace. Quien da seguimiento, gana."
        },
        {
          titulo: "PRIMER CONTACTO",
          porque:
            "Aquí se decide si competimos o no por la venta. Avanzar o soltar rápido."
        },
        {
          titulo: "PAGO PARCIAL",
          porque:
            "Ya compró. Primero se prioriza a quienes aún no se deciden."
        }
      ],

      noRequieren: ["CLIENTE NO CONTESTA", "NO INTERESADO", "SPAM"],

      dialogAlumnosSinConversacion: false,
      alumnosSinConversacion: [],

      alumnoSeleccionado: null,
      dialogSubirImagen: false,

      file: '',
      dragging: false,
      vistaPrevia: null,
      nivel1: false,

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

      filterAlumnosAsignados( ){

        let data = this.alumnos

        if( this.opAsignado == 1 ){
          data = data.filter( el => el.twilio_asignado )
        } else if( this.opAsignado == 2 ){
          data = data.filter( el => !el.twilio_asignado )
        }

        return data
      },

      filterAlumnosSinConversacion( ){

        let data = this.alumnosSinConversacion

        for( const i in data ){

          const { id_alumno } = data[i]

          // Buscar el alumno en la lista de alumnos calificaciones
          const alumnoCalificacion = this.alumnosCalificaciones.find( el => el.matricula.match( id_alumno ) )
          if( alumnoCalificacion ){
            data[i].calificacion          = alumnoCalificacion.total
            data[i].calificacion_anterior = alumnoCalificacion.total_anterior
            data[i].ultimo_movimiento     = alumnoCalificacion.ultimo_movimiento
          }

        }

        if( this.nivel1 ){
          return data.filter( el => el.id_nivel == 1  )
        }else{
          return data
        }

      },

      totalAlumnosSinConversacion() {
        return this.filterAlumnosSinConversacion.length
      },
      bajasSinConversacion() {
        return this.filterAlumnosSinConversacion.filter(el => el.baja_sn == 1 || el.baja_sn === '1').length
      },
      activosSinConversacion() {
        return this.filterAlumnosSinConversacion.filter(el => el.baja_sn == 0 || el.baja_sn === '0' || el.baja_sn === null || el.baja_sn === undefined).length
      },
      porLigarSinConversacion() {
        return this.totalAlumnosSinConversacion - this.bajasSinConversacion
      },

      filterAlumnosSinResponder( ){
        let data = this.planteles

        data = data.map( el => {
          // (el => !el.usuario && !el.usuario_asignado )
          let ultimoMensaje = this.filterChats.filter(pl => pl.id_plantel == el.idplantel && pl.mio == 1 ).length ? this.filterChats.filter(pl => pl.id_plantel == el.idplantel && pl.mio == 1 )[0].fecha_ultimo_mensaje : ''
          
          // chats = chats.filter(el => el.tiemporestante > 2)
          // chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
          // chats = chats.filter(el => el.tiemporestante <= 0)

          let mensajesSinResponder = this.filterChats.filter(pl => pl.id_plantel == el.idplantel && pl.mio == 0 )
          
          return {
            plantel: el.plantel,
            id_plantel: el.idplantel,
            sin_responder: mensajesSinResponder.length,
            cerrados: mensajesSinResponder.filter(el => el.tiemporestante <= 0).length,
            abiertos: mensajesSinResponder.filter(el => el.tiemporestante > 2).length,
            porcerrar: mensajesSinResponder.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2 ).length,
            ultimoMensaje: ultimoMensaje,
          }
        })

        // agregamos un total al final de la tabla
        data.push({
          plantel: 'Total',
          id_plantel: 0,
          sin_responder: this.filterChats.filter(pl => pl.mio == 0 ).length,
          ultimoMensaje: '', //this.filterChats.filter(pl => pl.mio == 1 )[0].fecha_ultimo_mensaje,
        })

        return data
      },

      filterAlumnosAsignadosPorPlantel( ){

        let data = this.planteles

        data = data.map( el => {
          // (el => !el.usuario && !el.usuario_asignado )
          return {
            plantel: el.plantel,
            cant_alumnos: this.alumnos.filter( alumno => alumno.id_plantel == el.idplantel ).length,
            sin_conversacion: this.alumnos.filter( alumno => alumno.id_plantel == el.idplantel && (!alumno.usuario && !alumno.twilio_asignado) ).length,
            sin_conversacion_alumnos: this.alumnos.filter( alumno => alumno.id_plantel == el.idplantel && !alumno.twilio_asignado ),
            con_conversacion: 0,
            asignados: this.alumnos.filter( alumno => alumno.id_plantel == el.idplantel && alumno.twilio_asignado ).length,
            sin_asignar: this.alumnos.filter( alumno => alumno.id_plantel == el.idplantel && !alumno.twilio_asignado ).length
          }
        })

        // agregamos un total al final de la tabla
        data.push({
          plantel: 'Total',
          cant_alumnos: this.alumnos.length,
          sin_conversacion: this.alumnos.filter( alumno =>  (!alumno.usuario && !alumno.twilio_asignado) ).length,
          sin_conversacion_alumnos: this.alumnos.filter( alumno => !alumno.twilio_asignado ),
          con_conversacion: this.filterChats.filter(el => !el.alumno ).length,
          asignados: this.alumnos.filter( alumno => alumno.twilio_asignado ).length,
          sin_asignar: this.alumnos.filter( alumno => !alumno.twilio_asignado ).length
        })

        return data
      },

    	conteoTiemposPorUsuario() {
    		const map = {}
    		let verdesTodos = 0
    		let amarillosTodos = 0
    		let sinResponderTodos = 0
    		const chats = Array.isArray(this.filterChats) ? this.filterChats : []

    		for (const chat of chats) {
    			if (!chat) continue
    			const id = Number(chat.usuario_asignado)
    			if (!id) continue
    			const t = Number(chat.tiemporestante)
    			if (!map[id]) {
    				map[id] = {
    					verdes: 0,
    					amarillos: 0,
    					sinResponder: 0,
    					horaSinContestarMs: 0,
    					horaSinContestar: '—',
    				}
    			}

    			if (t > 2) {
    				map[id].verdes++
    				verdesTodos++
    			} else if (t > 0 && t <= 2) {
    				map[id].amarillos++
    				amarillosTodos++
    			}

    			// Sin responder (icono azul): misma idea que filtroVistos, pero sin fuera de tiempo (chip rojo).
    			// - Reasignados IA, aunque el último mensaje sea nuestro
    			// - Último mensaje del lead (mio == 0)
    			// - Solo si aún hay tiempo (verde/amarillo); tiemporestante <= 0 no cuenta
    			const conTiempo = Number(chat.tiemporestante) > 0
    			if (conTiempo && (Number(chat.reasignado) === 1 || chat.reasignado === true || chat.mio == 0)) {
    				map[id].sinResponder++
    				sinResponderTodos++
    			}

    			aplicarHoraSinContestar(map[id], chat)
    		}

    		return {
    			map,
    			verdesTodos,
    			amarillosTodos,
    			sinResponderTodos,
    			...maxHoraSinContestarDeMap(map),
    		}
    	},

    	vendedorasConUsuario() {
    		const conteo = this.conteoTiemposPorUsuario

    		// Opción "Todos" al inicio
    		const colorTodos = colorHoraSinContestarGrupo(conteo.map)
    		const opcionTodos = {
    			iderp: null,
    			id_usuario_asignado: null,
    			nombre: 'Todos',
    			esTodos: true,
    			verdes: conteo.verdesTodos,
    			amarillos: conteo.amarillosTodos,
    			sinResponder: conteo.sinResponderTodos,
    			horaSinContestar: conteo.horaSinContestarTodos,
    			horaSinContestarMs: conteo.horaSinContestarTodosMs,
    			horaSinContestarColor: colorTodos,
    			horaSinContestarClase: claseTextoHoraSinContestar(colorTodos),
    		}

    		// Obtener la lista base de vendedoras
    		let listaBase = []
    		if (this.vendedorasTwilio && this.vendedorasTwilio.length > 0) {
    			listaBase = [...this.vendedorasTwilio]
    		} else if (this.vendedoras_plantel && this.vendedoras_plantel.length > 0) {
    			listaBase = [...this.vendedoras_plantel]
    		}

    		// Crear objeto del usuario actual
    		const usuarioActual = {
    			iderp: this.getdatosUsuarioERPERP.iderp,
    			id_usuario_asignado: this.getdatosUsuarioERPERP.iderp,
    			nombre: this.getdatosUsuarioERPERP.nombre_completo || this.getdatosUsuarioERPERP.nombre || 'Mi usuario',
    			esUsuarioActual: true
    		}

    		// Verificar si el usuario actual ya está en la lista
    		const usuarioYaExiste = listaBase.some(v => 
    			v.iderp === usuarioActual.iderp || 
    			v.id_usuario_asignado === usuarioActual.iderp ||
    			(v.idusuario && v.idusuario === this.getdatosUsuarioERPERP.id_usuario)
    		)

    		// Construir la lista final: Todos, Usuario Actual (si no existe), y luego las demás vendedoras
    		let listaFinal = [opcionTodos]
    		
    		// Si el usuario actual no existe, agregarlo después de "Todos"
    		if (!usuarioYaExiste && this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) {
    			listaFinal.push(usuarioActual)
    		}

    		// Agregar el resto de vendedoras
    		listaFinal = [...listaFinal, ...listaBase]

    		return listaFinal.map((item) => {
    			if (item.esTodos) return item
    			const id = Number(item.iderp || item.id_usuario_asignado || item.idusuario) || 0
    			const counts = conteo.map[id] || {
    				verdes: 0,
    				amarillos: 0,
    				sinResponder: 0,
    				horaSinContestar: '—',
    				horaSinContestarMs: 0,
    			}
    			const color = colorHoraSinContestar(counts.horaSinContestarMs)
    			return {
    				...item,
    				verdes: counts.verdes,
    				amarillos: counts.amarillos,
    				sinResponder: counts.sinResponder,
    				horaSinContestar: counts.horaSinContestar,
    				horaSinContestarMs: counts.horaSinContestarMs,
    				horaSinContestarColor: color,
    				horaSinContestarClase: claseTextoHoraSinContestar(color),
    			}
    		}).sort((a, b) => {
    			if (a.esTodos) return -1
    			if (b.esTodos) return 1
    			return (Number(b.verdes) || 0) - (Number(a.verdes) || 0)
    		})
    	}

    },

    methods:{

      obtenerCalificaciones( ){
        this.cargar = true;
        this.alumnosCalificaciones = [];
        const payload = {
          idCiclo  : !this.nameTwilio.match('FAST') ? 406 : 407,
          escuela  : !this.nameTwilio.match('FAST') ? 1 : 2,
          iderp    : 334,
          idpuesto : 11,
          planteles: [{"idplanteles_usuarios":256,"idusuario":5,"idplantel":1,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":257,"idusuario":5,"idplantel":2,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":258,"idusuario":5,"idplantel":3,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":259,"idusuario":5,"idplantel":4,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":260,"idusuario":5,"idplantel":5,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":261,"idusuario":5,"idplantel":6,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":262,"idusuario":5,"idplantel":7,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":263,"idusuario":5,"idplantel":8,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":264,"idusuario":5,"idplantel":9,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":265,"idusuario":5,"idplantel":10,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":266,"idusuario":5,"idplantel":11,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":267,"idusuario":5,"idplantel":12,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":268,"idusuario":5,"idplantel":14,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":269,"idusuario":5,"idplantel":16,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":270,"idusuario":5,"idplantel":17,"usuario_registro":0,"fecha_creacion":"2021-11-29 00:00:00","fecha_actualizo":"2021-11-29 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":659,"idusuario":5,"idplantel":21,"usuario_registro":0,"fecha_creacion":"2023-02-01 00:00:00","fecha_actualizo":"2023-02-01 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":1089,"idusuario":5,"idplantel":22,"usuario_registro":0,"fecha_creacion":"2023-05-20 00:00:00","fecha_actualizo":"2023-05-20 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":1090,"idusuario":5,"idplantel":23,"usuario_registro":0,"fecha_creacion":"2023-05-20 00:00:00","fecha_actualizo":"2023-05-20 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":1154,"idusuario":5,"idplantel":24,"usuario_registro":0,"fecha_creacion":"2023-09-12 00:00:00","fecha_actualizo":"2023-09-12 00:00:00","deleted":0,"prioridad":null},{"idplanteles_usuarios":1155,"idusuario":5,"idplantel":25,"usuario_registro":0,"fecha_creacion":"2023-09-12 00:00:00","fecha_actualizo":"2023-09-12 00:00:00","deleted":0,"prioridad":null}]
        };

        this.$http.post("riesgo.puntos", payload).then((response) => {
            let respuesta = response.data; //.filter( el => { return !el.grupo.match('KIDS') })
            console.log( respuesta[0] )
            this.calcularCalificaciones2(respuesta);

            //this.calcularCalificaciones(respuesta);
          }).catch((error) => {
          this.validarError(error);
        }).finally(() => {
          this.cargar = false;
        });
      },

      calcularCalificaciones2(value){
        for (const i in value){
          value[i].escuela = this.escuela;
          value[i].total = value[i].total.toFixed(2)
        }
        this.alumnosCalificaciones = value;
      },

      showButtons(){
        return esUsuarioTwilioAdmin(this.getdatosUsuarioERPERP.iderp) ||
          [334, 3015, 1, 568, 32, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472, 2556, 2574, 2767, 2817].includes(this.getdatosUsuarioERPERP.iderp) ||
          (this.vendedorasTwilio && this.vendedorasTwilio.length > 0)
      },
      idVendedoraItem(item) {
        if (!item || item.esTodos) return null
        const id = Number(item.iderp || item.id_usuario_asignado || item.idusuario)
        return Number.isFinite(id) && id > 0 ? id : null
      },
      conteoTiempoItem(item) {
        const map = this.conteoTiempoVendedores || {}
        if (item && item.esTodos) {
          return Object.keys(map).reduce((acc, key) => acc + (Number(map[key]) || 0), 0)
        }
        const id = this.idVendedoraItem(item)
        if (!id) return 0
        return Number(map[id]) || 0
      },
      etiquetaVendedora(item) {
        const nombre = (item && item.nombre) || ''
        return `${nombre} (${this.conteoTiempoItem(item)})`
      },
      handleSeleccionVendedora(item) {
        this.$emit('seleccionaVendedora', item)
      },

      abrirModalAsignados(){
        this.dialogAlumnosAsignados = true
      },

      abrirModalAsignadosPorPlantel(){
        this.obtenerCalificaciones( )
        this.dialogAlumnosAsignadosPorPlantel = true
      },

      abrirModalMensajesSinResponder(){
        this.dialogAlumnosSinResponder = true
      },

      verAlumnosSinConversacion( alumnos ){
        this.dialogAlumnosSinConversacion = true
        this.alumnosSinConversacion = alumnos
      },

      subirImagen( item ){
        this.alumnoSeleccionado = item
        this.dialogSubirImagen = true
      },

      async saveComentarios( item ){
        try{
          this.cargar = true
          await this.$http.post('whatsapp.comentarios.alumno', { id_alumno: item.id_alumno, comentarios: item.comentarios } )
          this.dialogAlumnosSinConversacion = false
        }catch( error ){
          this.validarErrorDirecto( error.response.data.message )
        }finally{
          this.cargar = false
        }
      },

      async actualizarBaja(item) {
        const valorAnterior = item.baja_sn == 1 || item.baja_sn === '1' ? 1 : 0
        try {
          this.cargar = true
          await this.$http.post('whatsapp.baja.alumno', { id_alumno: item.id_alumno, baja_sn: item.baja_sn })
        } catch (error) {
          item.baja_sn = valorAnterior ? 0 : 1
          this.validarErrorDirecto(error.response && error.response.data ? error.response.data.message : 'Error al actualizar baja')
        } finally {
          this.cargar = false
        }
      },

      async procesarImagen2( ){
        this.cargar = true
        this.isPracticaja = false

        var formData = new FormData();
        formData.append("file"             , this.archivos );
        formData.append("newVersion"       , '1' );
        formData.append("noPagos"          , this.noPagos );
        formData.append("id_alumno"        , this.alumnoSeleccionado.id_alumno );

        try{

          const resultado = await this.$http.post('lectura.imagenes.twilio', formData )

          //If we have got parsed results, then loop over the results to do something
          if (resultado) {
            // Guardamos las palabras
            this.texto_completo = resultado.data.numeroTelefono

            this.alumnoSeleccionado.numero_twilio = this.texto_completo

            this.removeFile( )
            // Ahora se necesita actualizar el alumno en la tabla de alumnos del front
            // Necesitamos guardar alumnos en una nueva variable, para limpiara y refrescar la tabla
            let alumnos = this.alumnosSinConversacion
            alumnos = alumnos.map( el => {
              if( el.id_alumno == this.alumnoSeleccionado.id_alumno ){
                el.twilio_texto = this.texto_completo
                return { ...el }
              }else{
                return el
              }
            })

            this.alumnosSinConversacion = alumnos

            this.dialogSubirImagen = false
          }

        }catch( error ){

          if( !this.noPagos ){

            this.removeFile( )

            if( ["DATE_TOO_OLD", "COMPROBANTE_RECHAZADO", "CUENTA_NO_VALIDA", "DUPLICATE_FOUND"].includes( error.response.data.code ) ){
              
              console.log( error.response.data )
              return this.validarErrorDirecto( error.response.data.message )

            }

            this.validarError( error )
          }


        }finally{

          this.cargar = false
        
        }
      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        
        if (!files.length) {
          this.dragging = false;
          return;
        }
        
        this.createFile(files[0]);
      },

      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('please select txt file');
          this.dragging = false;
          return;
        }
        
        if (file.size > 10000000) {
          alert('please check file size no over 5 MB.')
          this.dragging = false;
          return;
        }
        
        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos)
        this.procesarImagen2( )
        this.dragging = false;
      },

      getBase64(file) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevia = {
            url: reader.result, 
            image_name: file.name
          }
        };
      },

      removeFile() {
        this.vistaPrevia  = null
        this.archivos     = null
        this.file         = '';
      },

      async pegar(event) {
        console.log( event )
        if (event.code == "KeyV") {
          const { type, value } = await Clipboard.read();

                    // Validamos que sea de tipo imagen
          if (type == "image/png") {
                    // Convertimos el base64 en una imagen
            const file = this.convertFile(value, "imagen.png");
            this.createFile(file);
          }
        }
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },
    }

  }
</script>
<style scoped lang="scss">
  @import '@/assets/styles/twilio-whatsapp-layout.scss';

  .wa-vendedoras-menu {
    min-width: 440px;
    max-width: 560px;
  }

  #grupos td:nth-child(1) {
    background-color: #E8E8E8 !important;
  }

  #grupos td{
    font-size: 12px !important;
    padding-left: 5px;
    padding-right: 5px;
  }

  .adeudo_alumno{
  	background-color: #FF3030 !important;
  	color: white;
  }

  .alumno_ri{
  	background-color: #8CC339 !important;
  	color: white;
  }

  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }

</style>
